<template>
  <div class="VB_Brochure_Art" ref="art" @dragstart.stop.prevent></div>
</template>

<script>
export default {
  name: "ViewmedicaBrochureArt",

  props: {
    image: {
      required: true
    }
  },

  mounted() {
    if (!this.image) return;
    this.image.title = `${this.$store.getters.pageTitle} Art`;
    this.$refs.art.appendChild(this.image);
  }
};
</script>

<style lang="scss">
.VB_Brochure_Art {
  position: absolute;
  left: 24pt;
  top: 100pt;
  width: 335pt;
  height: 664pt;

  & img {
    padding: 0;
    margin: 0;
    max-width: 100%;
    max-height: 100%;
    width: auto;
  }

  & iframe {
    padding: 0;
    margin: 0;
    width: 100%;
    height: 680pt;
  }

  & embed {
    padding: 0;
    margin: 0;
    width: 100%;
    height: 680pt;
  }
}
</style>
